import React from 'react';

const InvestmentGoalsIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M16 3C16 3 23 7.5 23 16.5C23 19 21.5 21 21.5 21H10.5C10.5 21 9 19 9 16.5C9 7.5 16 3 16 3Z" fill="#66BB6A"/>
        <path d="M16 3C16 3 23 7.5 23 16.5C23 19 21.5 21 21.5 21H10.5C10.5 21 9 19 9 16.5C9 7.5 16 3 16 3Z" fill="url(#investmentRocketShine)"/>
        <circle cx="16" cy="13" r="3.6" fill="#FFE699"/>
        <circle cx="16" cy="13" r="3.6" fill="none" stroke="#F0C24B" strokeWidth="0.6"/>
        <circle cx="14.8" cy="11.8" r="1" fill="#fff" opacity="0.6"/>
        <path d="M9 17.5 L4.5 22 L9.5 20.5Z" fill="#EF9A9A"/>
        <path d="M23 17.5 L27.5 22 L22.5 20.5Z" fill="#EF9A9A"/>
        <path d="M13 21 L11.5 27 L16 24.5 L20.5 27 L19 21" fill="#4FA3E8" opacity="0.85"/>
        <path d="M13 21 L11.5 27 L16 24.5 L20.5 27 L19 21" fill="url(#investmentFlameShine)"/>
        <circle cx="25" cy="6" r="1.3" fill="#F5C518"/>
        <circle cx="27.5" cy="10.5" r="0.9" fill="#66BB6A"/>
        <circle cx="6" cy="9" r="0.9" fill="#F5C518" opacity="0.7"/>
        <defs>
            <linearGradient id="investmentRocketShine" x1="9" y1="3" x2="23" y2="21" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#fff" stopOpacity="0.3"/>
                <stop offset="0.55" stopColor="#fff" stopOpacity="0"/>
                <stop offset="1" stopColor="#000" stopOpacity="0.08"/>
            </linearGradient>
            <linearGradient id="investmentFlameShine" x1="11.5" y1="21" x2="20.5" y2="27" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#fff" stopOpacity="0.35"/>
                <stop offset="1" stopColor="#fff" stopOpacity="0"/>
            </linearGradient>
        </defs>
    </svg>
);

export default InvestmentGoalsIcon;